import { createContext, type MiddlewareFunction } from 'react-router';
import { datadogRum } from '@datadog/browser-rum';
import * as tokenExchangeService from '~/evaluator/service/token-exchange.service';
import type { ValidatedToken } from '~/evaluator/service/token-exchange.service';

export const tokenContext = createContext<ValidatedToken>();

export async function validateToken({
  request,
  context,
}: MiddlewareArgs): Promise<void> {
  const token = tokenFromHash(window.location.hash);
  const dialect = new URL(request.url).searchParams.get('dialect') ?? undefined;

  if (validatedToken?.token !== token)
    validatedToken = await validate(token, dialect);

  context.set(tokenContext, validatedToken);
}

export class MissingTokenError extends Error {}

type MiddlewareArgs = Parameters<MiddlewareFunction>[0];

let validatedToken: ValidatedToken | undefined;

async function validate(
  token: string,
  dialect: string | undefined,
): Promise<ValidatedToken> {
  const result = await tokenExchangeService.validateToken({ token, dialect });

  datadogRum.setUser({ id: result.token });
  return result;
}

function tokenFromHash(hash: string): string {
  const token = new URLSearchParams(hash.slice(1)).get('token');
  if (!token) throw new MissingTokenError();
  return token;
}

export function clearValidatedToken(): void {
  validatedToken = undefined;
}
